<router-outlet></router-outlet>
<p-toast position="top-right" />
<p-toast class="toast_notification" key="notification" position="bottom-right">
  <ng-template let-message pTemplate="message">
    <div
      (click)="openNotifications()"
      class="custom-toast"
      [id]="['notification_push_' + message.data?.id]"
    >
      @if (message.severity === 'info') {
        <mat-icon class="icon-notification">notifications-active</mat-icon>
      }
      <div class="toast-content">
        <strong
          class="toast-content__title"
          [id]="'notification_push_title_' + message.data?.id"
          >{{ message.summary }}</strong
        >
        @if (message?.detail) {
          <p [id]="['notification_push_detail_' + message.data?.id]">
            {{ message.detail }}
          </p>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
